export const ccTownListSchema = {
	schema: {
		title: 'cc town list schema',
		description: 'CC Town List Schema',
		version: 0,
		primaryKey: 'towncode_c',
		type: 'object',
		properties: {
			towncode_c: {
				type: 'string',
				maxLength: 250,
			},
			towndescription_c: {
				type: 'string',
			},
			town_c: {
				type: 'string',
			},
			sfid: {
				type: 'string',
			},
			pidilite_user_c: {
				type: 'string',
			},
			createddate: {
				type: 'string',
			},
		},
		required: ['towncode_c', 'towndescription_c'],
	},
};
